export const AVATAR_GROUP = {
  ORIENTATION: { HORIZONTAL: "horizontal", VERTICAL: "vertical" },
};